import script from "./registration-message.vue?vue&type=script&setup=true&lang=js"
export * from "./registration-message.vue?vue&type=script&setup=true&lang=js"

import "./registration-message.vue?vue&type=style&index=0&id=43e6baf1&lang=scss"

const __exports__ = script;

export default __exports__